import { useUpdateInsightsTimeframeMutation } from 'shared/hooks/queries/use-update-insights-timeframe-mutation';

export const useUpdateInsightsTimeframe = () => {
  const { mutate } = useUpdateInsightsTimeframeMutation();

  return mutate;
};
